import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "h-auto",
    style: _normalizeStyle({ 'width': _ctx.getWidth() })
  }, [
    _createElementVNode("img", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.redirect && _ctx.redirect(...args))),
      src: _ctx.getSource(),
      class: "m-0 p-0 block border-0"
    }, null, 8, _hoisted_1)
  ], 4))
}